import React from 'react'
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

const NewButton = ({label, ...props}) => {
  return (
    
      
      <Button variant="outlined"  size='large' {...props}>
        {label}
      </Button>
      
  )
}

export default NewButton